import { Injectable, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LoginAuthUserInputFields } from '@com-delta-idp/mnx-login-ui';
import { OauthAEMConfig } from '@com-delta-idp/mnx-oauth';
import { CookieHelperService } from '@com-delta-idp/mnx-utils';
import { CoreUtilService } from '../../utils/core-util.service';
import { LoginHelperUtils } from '../../utils/login-helper.utils';
import { FROM_APP, RESTRICT_AUTH_CALLS_URL } from '../constants/login-constant';
import { LoginModalContent } from '../models/aem';
import { LoginModalHelperService } from '../services';
import { PingLoginAdapterService } from './ping-login-adapter.service';

@Injectable({
  providedIn: 'root'
})
export class LoginContentAdapterSupportService {
  helper = inject(LoginModalHelperService);
  pingAdapter = inject(PingLoginAdapterService);
  cookieHelper = inject(CookieHelperService);
  coreUtilService = inject(CoreUtilService);
  actiavtedRoute = inject(ActivatedRoute);
  utilHelper = inject(LoginHelperUtils);

  setRememberMeValue(
    userInputFields: LoginAuthUserInputFields | undefined
  ): string {
    const promptCookie = this.cookieHelper.getCookieValue('prompt');
    const promptCookieAvailable = promptCookie ? true : false;
    const encryptedTokenStored = this.coreUtilService.get('encyToken');
    const uniqueIdentifierStored = this.coreUtilService.get('uid');
    if (
      this.setRememberMeValueCheck(
        promptCookieAvailable,
        userInputFields,
        encryptedTokenStored,
        uniqueIdentifierStored
      )
    ) {
      return 'Y';
    } else {
      return 'N';
    }
  }

  setRememberMeValueCheck(
    promptCookieAvailable: boolean,
    userInputFields: LoginAuthUserInputFields | undefined,
    encryptedTokenStored: string | null,
    uniqueIdentifierStored: string | null
  ) {
    return (
      !promptCookieAvailable &&
      !userInputFields &&
      (encryptedTokenStored || uniqueIdentifierStored)
    );
  }

  getFromApp(standalonePage: boolean): string {
    let fromApp = '';
    if (standalonePage) {
      fromApp = this.actiavtedRoute.snapshot.queryParamMap.get(
        FROM_APP
      ) as string;
    }
    return fromApp;
  }

  fromAppCheck(standalonePage: boolean, fromApp: string) {
    return (
      standalonePage &&
      this.actiavtedRoute.snapshot.queryParamMap.get(FROM_APP) &&
      !fromApp
    );
  }

  setPersistentLoginValue(
    userInputFields: LoginAuthUserInputFields | undefined
  ) {
    return userInputFields?.persistentLogin
      ? userInputFields?.persistentLogin
      : 'N';
  }

  async getLoginContent(
    loginAemResponse: LoginModalContent,
    config: OauthAEMConfig,
    skyMilesNumber: string
  ) {
    const restrictAuthCallUrls =
      config.RESTRICT_AUTH_CALLS_URL ?? RESTRICT_AUTH_CALLS_URL;

    return {
      formGroup: this.helper.createLoginForm(config),
      loginFormAttributes: this.helper.getLoginFormAttributes(),
      pageContent: this.helper.getLoginAuthenticationScreenContent(
        loginAemResponse,
        config
      ),
      authenticationEnabled: restrictAuthCallUrls.some((item) =>
        window.location.href.includes(item)
      )
        ? ''
        : await this.pingAdapter.processPingAutenticationStarts(config),
      skyMilesNumber: skyMilesNumber
    };
  }
}
